import CheckmarkCircleFill from '@crehana/compass.icons.fill/CheckmarkCircle';
import CloseCircle from '@crehana/compass.icons.fill/CloseCircle';
import CheckmarkCircleOutline from '@crehana/compass.icons.outline/CheckmarkCircle';
import { clsx } from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RULE_ICON = {
  pending: {
    Icon: CheckmarkCircleOutline,
    className: 'tw-text-neutral-light-700'
  },
  met: {
    Icon: CheckmarkCircleFill,
    className: 'tw-text-success-500'
  },
  failed: {
    Icon: CloseCircle,
    className: 'tw-text-alert-400'
  }
};
var getRuleState = function getRuleState(rule, password) {
  if (password === '') {
    return 'pending';
  }
  try {
    return new RegExp(rule.regex).test(password) ? 'met' : 'failed';
  } catch (_unused) {
    return 'failed';
  }
};
export var PasswordRulesList = function PasswordRulesList(_ref) {
  var rules = _ref.rules,
    password = _ref.password,
    title = _ref.title;
  if (rules.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-flex-col tw-gap-0.8 tw-mt-1.2 tw-border tw-border-solid tw-cds-border-default tw-cds-rounded-s tw-cds-bg-layer-02 tw-cds-p-4",
    children: [/*#__PURE__*/_jsx("p", {
      className: "tw-font-caption tw-text-neutral-light-600 tw-uppercase tw-mb-0.4",
      children: title
    }), rules.map(function (rule) {
      var state = getRuleState(rule, password);
      var _RULE_ICON$state = RULE_ICON[state],
        Icon = _RULE_ICON$state.Icon,
        className = _RULE_ICON$state.className;
      return /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-items-center tw-gap-0.8",
        children: [/*#__PURE__*/_jsx(Icon, {
          size: 16,
          className: className
        }), /*#__PURE__*/_jsx("span", {
          className: clsx(className, 'tw-cds-font-body-01'),
          children: rule.description
        })]
      }, rule.id);
    })]
  });
};